// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Brgv0i1TxjId5_6sjytk{width:90%;max-width:700px;height:100px;display:flex;flex-direction:column}.Brgv0i1TxjId5_6sjytk .hBvS8e_8HZMCjbRk9NNP{display:flex;flex-direction:column;gap:2em}.Brgv0i1TxjId5_6sjytk .hBvS8e_8HZMCjbRk9NNP .eSrmM7DatejGdcks_ckg{display:flex;flex-direction:row;gap:2em;align-items:center;min-height:3em}.Brgv0i1TxjId5_6sjytk .hBvS8e_8HZMCjbRk9NNP .eSrmM7DatejGdcks_ckg .lu42MWipXRTunVJqj9i0{flex:1 1 150px;min-width:100px;max-width:250px}.Brgv0i1TxjId5_6sjytk .hBvS8e_8HZMCjbRk9NNP .eSrmM7DatejGdcks_ckg .lu42MWipXRTunVJqj9i0 div:first-child{width:100%;max-width:150px;text-align:center}.Brgv0i1TxjId5_6sjytk .y8aHJnH1yviXgC_KaauA{margin-top:2em;display:flex;justify-content:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `Brgv0i1TxjId5_6sjytk`,
	"slidersContainer": `hBvS8e_8HZMCjbRk9NNP`,
	"sliderRow": `eSrmM7DatejGdcks_ckg`,
	"pillContainer": `lu42MWipXRTunVJqj9i0`,
	"buttonRow": `y8aHJnH1yviXgC_KaauA`
};
export default ___CSS_LOADER_EXPORT___;
